var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusContour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A9E928C0-FB2C-4CF7-8238-27A9E2188010") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V1-hp-jardiner",
    transform: "translate(-22.000000, -238.000000)",
    fill: "#F0F9FA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus-(3)",
    transform: "translate(22.000000, 238.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3507813,0 L4.64921875,0 C2.08271484,0.00288085937 0.00288085937,2.08271484 0,4.64921875 L0,20.3507813 C0.0029296875,22.9172852 2.08271484,24.9970703 4.64921875,25 L20.3507813,25 C22.9172852,24.9970703 24.9970703,22.9172852 25,20.3507813 L25,4.64921875 C24.9970703,2.08271484 22.9172852,0.0029296875 20.3507813,0 Z M23.2741699,20.3507813 C23.2723145,21.9645508 21.9645508,23.2723145 20.3507813,23.2741699 L4.64921875,23.2741699 C3.03544922,23.2723633 1.72768555,21.9645996 1.72583008,20.3507813 L1.72583008,4.64921875 C1.72763672,3.03544922 3.03540039,1.72763672 4.64921875,1.72583008 L20.3507813,1.72583008 C21.9645508,1.72763672 23.2723145,3.03540039 23.2741699,4.64921875 L23.2741699,20.3507813 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3959961,11.6370605 L13.3629395,11.6370605 L13.3629395,6.60400391 C13.3629395,6.12744141 12.9766113,5.74106445 12.5,5.74106445 C12.0233887,5.74106445 11.6370605,6.12739258 11.6370605,6.60400391 L11.6370605,11.6371094 L6.60400391,11.6371094 C6.12744141,11.6371094 5.74106445,12.0234375 5.74106445,12.5000488 C5.74106445,12.9766602 6.12739258,13.3629883 6.60400391,13.3629883 L11.6371094,13.3629883 L11.6371094,18.3959961 C11.6371094,18.8725586 12.0234375,19.2589355 12.5000488,19.2589355 C12.9766602,19.2589355 13.3629883,18.8726074 13.3629883,18.3959961 L13.3629883,13.3629395 L18.3959961,13.3629395 C18.8725586,13.3629395 19.2589355,12.9766113 19.2589355,12.5 C19.2589355,12.0233887 18.8726074,11.6370605 18.3959961,11.6370605 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusContour);
export default __webpack_public_path__ + "static/media/plus-contour.76998654053efc0e334e50c61ac094f3.svg";
export { ForwardRef as ReactComponent };